module.exports = __webpack_public_path__ + "img/af.064626ed.svg";